module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight-d4be85c92e620acc05f9fd61589af3f7.png";